<template>
    <div id="addMonitor" v-if="isAuth('common:interface')">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="returnBtn">监测点管理</span><span class="arrow">></span><span>{{linkTxt}}</span>
        </div>
        <div> 
          <el-button type="primary" v-show="IStrue" @click="deleteMonitoring" v-if="isAuth('basicData:delMonitorById')">删除</el-button>
          <el-button type="primary" v-if="isAuth('basicData:updateMonitorInfo')" v-show="IStrue" @click="editMonitoring">编辑</el-button>
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="fixedScorll" :style="{height: heightCard + 'px'}">
        <div class="maindetails" :style="{height: heightBg + 'px'}">
            <el-form :model="ruleForm" ref="ruleForm" label-width="105px" class="demo-ruleForm" :disabled="IStrue">
                <el-form-item label="监测点名称:" prop="monitoringName" :required="!IStrue" :show-message="false"> 
                    <el-input v-model="ruleForm.monitoringName" placeholder="长度不超过20个字符" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="监测点编号:" prop="monitoringCode" :required="!IStrue" :show-message="false">
                    <el-input v-model="ruleForm.monitoringCode" placeholder="长度不超过20位的字母、数字或下划线" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="启用状态:" prop="enabled" :required="!IStrue" :show-message="false">
                    <el-select v-model="ruleForm.enabled">
                        <el-option label="启用" :value="false"></el-option>
                        <el-option label="禁用" :value="true"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI码:" prop="deviceIMEI" :required="!IStrue" :show-message="false">
                    <div class="inlieInput">
                        <el-autocomplete v-model="ruleForm.deviceIMEI" placeholder="请输入IMEI码" :fetch-suggestions="querySearchAsync" value-key="deviceimei" @select="handleSelect" onkeyup="value=value.replace(/[^\d]/g,'')" @change='changeIMEIVal'></el-autocomplete>
                        <el-button type="primary" @click="searchSenior" v-show="!IStrue">高级搜索</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="监测类型:" prop="type" class="txtcolor">
                    <span v-if="this.ruleForm.type == 1">电气</span>
                    <span v-else-if="this.ruleForm.type == 2">水压</span>
                    <span v-else-if="this.ruleForm.type == 3">液位</span>
                    <span v-else-if="this.ruleForm.type == 4">可燃气</span>
                    <span v-else-if="this.ruleForm.type == 5">烟感</span>
                    <span v-else-if="this.ruleForm.type == 6">灭火器</span>
                    <span v-else-if="this.ruleForm.type == 7">水浸</span>
                    <span v-else-if="this.ruleForm.type == 8">用传</span>
                    <span v-else>--</span>
                </el-form-item>
                <el-form-item label="安装地址:" prop="installAddress" class="txtcolor">
                    <span class="addressClass" v-html="(this.ruleForm.installAddress).replace(/\|/g, '<span>|</span>')"></span>
                </el-form-item>
                <el-form-item label="详细地址:" prop="detailAddress" :required="!IStrue" :show-message="false">
                    <el-tooltip class="item"  :content="ruleForm.detailAddress" :disabled="IStrue ? len : true" placement="bottom-start">
                        <el-input v-model="ruleForm.detailAddress" placeholder="长度不超过30个字符" :maxlength="30" @mouseover.native="changeText1()" ref="detailAddressLength"></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="备注:" prop="remark">
                    <el-input type="textarea" :rows="5" v-model="ruleForm.remark"></el-input>
                </el-form-item>
                <el-form-item v-show="!IStrue">
                    <el-button style="margin-top:20px;" type="primary" @click="submitForm('ruleForm')" v-if="(typeUrl=='add'|| typeUrl=='edit')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>
    <!-- 设备绑定信息弹出框 -->
    <el-dialog title="设备绑定" :visible.sync="dialogTableVisible" width="652px" class="deviceCss" :modal-append-to-body="false">
        <div class="deviceBinding">
            <div>
                <el-select v-model="devicetypeid" placeholder="全部" @change="selectChange" :disabled="istrue">
                    <!-- <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.type"> </el-option> -->
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.type"> </el-option>
                </el-select>
            </div>
            <div class="searchBtn" @mousemove="mousearch">
                <i></i>
                <el-input placeholder="搜索设备名称、IMEI码" v-model="searchInput" clearable @blur="searchInputChange()" @clear="clearableBack" ref="inputRef"></el-input>
            </div>
        </div>
        <el-table :data="gridData" style="max-width:611px;min-height:312px;" max-height="312px" @current-change="handleCurrentChange" highlight-current-row border class="user_table">
            <el-table-column property="typeName" label="设备型号" width="102" show-overflow-tooltip></el-table-column>
            <el-table-column property="devicename" label="设备名称" width="300" show-overflow-tooltip></el-table-column>
            <el-table-column property="deviceimei" label="IMEI码" width="208" show-overflow-tooltip></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button style="min-width:80px;" @click="dialogTableVisible = false">取 消</el-button>
            <el-button style="min-width:80px;margin-left:8px;" type="primary" @click="bindValue">确 定</el-button>
        </div>
    </el-dialog>
    <!-- 提示框(自动消失) -->
    <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" :closeOnClickModal="false">
        <span>{{tips}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
        </span>
    </el-dialog>
    <!-- 确认提示框 -->
    <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsSureVisible" :modal-append-to-body="false">
        <div>{{tipsTwo}}</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTipsSureVisible=false">取 消</el-button>
            <el-button type="primary" @click="TipsSure(sureType)">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'addMonitor',
        props:['infoId'],
        data() {
            return {
                istrue:true,
                FourType:'',
                len: true,
                activeIndex:"'4-1'", //Top导航选中值
                heightCard:'',
                heightBg:'',
                ruleForm: { //表单提交数据
                    monitoringName: '', //名称
                    monitoringCode:'', //编号
                    enabled: false, //状态
                    type: '', //设备类型 2
                    deviceId:'', //设备id  12
                    installAddress:'', //安装地址
                    detailAddress: '', //详细地址
                    deviceIMEI: '', //IMEI  001456
                    customerId:'', //客户id
                    buildingId:'', //建筑id
                    remark: '', //备注
                    linkTxt:''
                },
                imeiCompare:-1, //比较imei
                IStrue:false, //是否是查看详情
                sureType:'', //确认状态
                restaurants: [], //模糊下拉框
                gridData: [], //弹层表格数据
                    dialogTableVisible: false,
                    dialogTipsVisible:false, //自动消失提示
                    dialogTipsSureVisible:false, //确认提示
                    tips:'信息填写不完善，请完善信息！', //提示语
                    tipsTwo:'本次编辑内容尚未保存，确定退出吗？', //确认提示语
                     options: [{
                        type: '',
                        label: '全部'
                        }, {
                        type: '25e6d6b9948a49f8b1f3f2ebaf7dbaca',
                        label: '电气'
                        }, {
                        type: '3177e2a539a24a8da5900b5e0fbd0fgg',
                        label: '水压'
                        }, {
                        type: 'add413d5-3417-4fe7-87f7-6b0917e7a88b',
                        label: '液位'
                        }, {
                        type: '847ccc1042a54e1aa5aa5eba24554dbb',
                        label: '可燃气'
                        }, {
                        type: '1751add6-a9d9-4fd5-b565-4f24bf5bb65a',
                        label: '烟感'
                        }, {
                        type: '337e9236-67c2-4114-8390-f0d0260d7e9b',
                        label: '灭火器'
                        }, {
                        type: 'add413d5-3417-4fe7-87f7-6b0917edh3b',
                        label: '水浸'
                        }, {
                        type: 'add413d5-3417-4fe7-87f7-6b0917edjkl',
                        label: '用传'
                        }],
                        devicetypeid:'',//默认项下拉值
                        searchInput:'',//搜索框的值
                        handleCurrentVal:'', //缓存表格选中的值
                        typeUrl:'',
                        windowResize:null,
                        target:0,
            }
        },
        watch: {
            ruleForm:{
              handler(curVal,oldVal){
                  if(sessionStorage.getItem('changeVal')){
                    var changeVal = JSON.parse(sessionStorage.getItem('changeVal'));
                  }else{
                       var changeVal = {
                           monitoringName:'',
                           monitoringCode:'',
                           deviceIMEI:'',
                           detailAddress:'',
                           remark:''
                       }
                  }
                let a = this.ruleForm.monitoringName == changeVal.monitoringName && this.ruleForm.monitoringCode == changeVal.monitoringCode && this.ruleForm.deviceIMEI == changeVal.deviceIMEI && this.ruleForm.detailAddress == changeVal.detailAddress && this.ruleForm.remark == changeVal.remark;
                if((this.ruleForm.monitoringName !='' || this.ruleForm.monitoringCode !='' || this.ruleForm.deviceIMEI !='' || this.ruleForm.detailAddress !='' || this.ruleForm.remark != '') && this.IStrue == false && !a){
                    sessionStorage.setItem('complete',false)//左侧导航判断内容是否填写完整
                }else{
                    sessionStorage.setItem('complete',true) //左侧导航判断内容是否填写完整
                }
              },
              　deep:true　
            }
        },
        created() {
            this.$emit('getActive', "4-1"); //导航定向
            if(this.$route.query.IStrue == 'true'){
                this.linkTxt = '查看监测点';
                this.IStrue = true;
                this.istrue = true;
                this.getDetails(sessionStorage.getItem('saveId')); //详情数据
            }else if(this.$route.query.IStrue == 'false'){
                this.linkTxt = '编辑监测点';
                this.IStrue = false;
                this.istrue = false;
                this.typeUrl='add';
                this.obtainAddressAjax();
            }else if(this.$route.query.IStrue == 'edit'){
                this.linkTxt = '编辑监测点';
                this.IStrue = false;
                this.istrue = true;
                this.typeUrl='edit';
                this.getDetails(sessionStorage.getItem('saveId')); //详情数据
            }
        },
        methods: {
            dialogTipsSureVisibleClick(){
             this.dialogTipsSureVisible=false;
             this.devicetypeid = ''
            },
            changeIMEIVal(val){
                this.ruleForm.deviceIMEI = val;
            },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('maindetails')[0].style.marginRight=0;
              }else {
                document.getElementsByClassName('maindetails')[0].style.marginRight='1.05%';
              }
            });
          },
            changeText1() {
                let _this = this
                let len = 0;
                let val = _this.$refs.detailAddressLength.value;
                for (var i = 0; i < val.length; i++) {
                    var a = val.charAt(i);
                    if (a.match(/[^\x00-\xff]/ig) != null) {
                        len += 2;
                    } else {
                        len += 1;
                    }
                }
                if (len/2 * 13 > 282) {
                    this.len = false;
                } else {
                    this.len = true;
                }
            },
            returnBtn(){ //返回按钮;
                  if(sessionStorage.getItem('changeVal')){
                    var changeVal = JSON.parse(sessionStorage.getItem('changeVal'));
                  }else{
                       var changeVal = {
                           monitoringName:'',
                           monitoringCode:'',
                           deviceIMEI:'',
                           detailAddress:'',
                           remark:''
                       }
                  }
                let a = this.ruleForm.monitoringName == changeVal.monitoringName && this.ruleForm.monitoringCode == changeVal.monitoringCode && this.ruleForm.deviceIMEI == changeVal.deviceIMEI && this.ruleForm.detailAddress == changeVal.detailAddress && this.ruleForm.remark == changeVal.remark;
                if((this.ruleForm.monitoringName !='' || this.ruleForm.monitoringCode !='' || this.ruleForm.deviceIMEI !='' || this.ruleForm.detailAddress !='' || this.ruleForm.remark != '') && this.IStrue == false && !a){
                    this.tipsTwo = '本次编辑内容尚未保存，确定退出吗？' //确认提示语
                    this.dialogTipsSureVisible = true;
                    this.sureType = 'return';
                    sessionStorage.setItem('complete',false)//左侧导航判断内容是否填写完整
                }else{
                    this.$router.push({path:'/content/BasicData'}); //监测点首页
                    sessionStorage.setItem('complete',true) //左侧导航判断内容是否填写完整
                    sessionStorage.setItem('returnType',1) //区分是否保留筛选条件历史记录
                }
            },
            TipsSure(sureType){ //确认提示
               if(sureType == 'return'){
                   sessionStorage.setItem('returnType',1) //区分是否保留筛选条件历史记录
                   this.$router.push({path:'/content/BasicData'}); //监测点首页
               }else if(sureType == 'delete'){
                   let parms={
                        id:sessionStorage.getItem('saveId')
                   }
                    ajaxFuncJson('/basicData/delMonitorById',parms).then(res=>{
                        if(res.data.status == 200){
                           this.$router.push({path:'/content/deleteSuccessfully'});
                        }else if(res.data.status == 305){
                            this.dialogTipsSureVisible = false;
                            this.tips = res.data.msg;
                            this.dialogTipsVisible = true;
                            let that = this;
                            let test1 = setTimeout(function(){ //提示框
                                that.dialogTipsVisible = false;
                                clearTimeout(test1);
                            },5000)
                        }
                    })
               }
            },
            editMonitoring(){ //编辑监测点
                this.IStrue = false;
                this.getDetails(sessionStorage.getItem('saveId')); //详情数据
                this.linkTxt = '编辑监测点';
                this.typeUrl='edit';
                this.$router.push({path:'/content/addMonitor',query:{IStrue:'edit'}}); 
            },
             querySearchAsync(queryString, cb) { //关键字索引
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                cb(results);
            },
            createStateFilter(queryString) { //关键字索引全值
                return (state) => {
                return (state.deviceimei.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) { //保存页缓存条件值
                let deptid;
                if(sessionStorage.getItem("userType")==1){
                  deptid = ''
                }else{
                  deptid = sessionStorage.getItem("customerId");
                }
                let parms = {
                    type:this.FourType,
                    searchKey: item.deviceimei,//搜名称
                    deptid:deptid
                }
                ajaxFuncJson('/monitoring/checkDeviceList',parms).then(res=>{
                    if(res.data.status == 200){
                        let searchVal = res.data.data
                        this.ruleForm.type = searchVal[0].type; //检测点类型
                        this.ruleForm.deviceId = searchVal[0].id;  //设备id
                    }
                })
            },
            deleteMonitoring(){ //删除检测点
                this.deleteMonitoringAjax(sessionStorage.getItem('saveId')); //删除请求
            },
            selectChange(){ //弹层下拉搜索
               let deptid;
                if(sessionStorage.getItem("userType")==1){
                  deptid = ''
                }else{
                  deptid = sessionStorage.getItem("customerId");
                }

                let parms = {
                    type:this.FourType,
                    devicetypeid:this.devicetypeid, //搜类型
                    searchKey: this.searchInput, //搜名称
                    deptid:deptid,
                }
              this.searchSeniorAjax(parms); //弹层内容
            }, 
            searchInputChange(){ //弹层搜索失去焦点
              if(this.target==1){
                this.searchInput = '';
                this.$refs.inputRef.$el.children[0].focus();
                this.target = 0
              }else {
                let deptid;
                if(sessionStorage.getItem("userType")==1){
                  deptid = ''
                }else{
                  deptid = sessionStorage.getItem("customerId");
                }
                let parms = {
                  type:this.FourType,
                  devicetypeid:this.devicetypeid, //搜类型
                  searchKey:  this.searchInput ,//搜名称
                  deptid:deptid,
                };
                this.searchSeniorAjax(parms); //弹层内容
              }
            },
            mousearch(event){
              if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
                this.target = 1;
              }else{
                this.target = 0
              }
            },
            clearableBack(){ //清除回调
               this.$refs.inputRef.$el.children[0].focus();
            },
            bindValue(){ //IMEI确定之后的值
                this.ruleForm.deviceIMEI = this.handleCurrentVal;
                // let deptid;
                // if(sessionStorage.getItem("userType")==1){
                //   deptid = ''
                // }else{
                //   deptid = sessionStorage.getItem("customerId");
                // }
                // let parms = {
                //     type:this.FourType,
                //     searchKey: this.ruleForm.deviceIMEI,//搜IMEI
                //     deptid:deptid,
                // }
                // ajaxFuncJson('/monitoring/checkDeviceList',parms).then(res=>{
                //     if(res.data.status == 200){
                //         let searchVal = res.data.data
                //         if(searchVal.length > 0){
                //             this.ruleForm.type = searchVal[0].type; //检测点类型
                //             this.ruleForm.deviceId = searchVal[0].id;  //设备id
                //         }
                //     }
                // })
                this.dialogTableVisible = false; //关闭弹层
            },
            searchSenior(){ //高级搜索按钮
              var deptid;
              if(sessionStorage.getItem("userType")==1){
                deptid = ''
              }else{
                deptid = sessionStorage.getItem("customerId");
              }
              var param = {
                type:this.FourType,
                deptid:deptid,
              }
              this.devicetypeid = '';
              this.searchInput = '';
              this.searchSeniorAjax(param); //弹层内容
              this.dialogTableVisible = true;
            },
            handleCurrentChange(val){ //选中的IMEI码
               if(val){
                   this.handleCurrentVal = val.deviceimei;
                   this.ruleForm.type = val.type;
               }
            },
            submitForm(formName) { //保存
                this.ruleForm.customerId = sessionStorage.getItem("customerId"); //赋值客户id
                this.ruleForm.buildingId = sessionStorage.getItem("buildingId");; //赋值建筑id
                this.$refs[formName].validate((valid) => {
                if (valid) {

                  let deptid;
                  if(sessionStorage.getItem("userType")==1){
                    deptid = ''
                  }else{
                    deptid = sessionStorage.getItem("customerId");
                  }

                   let parms = {
                        type:this.FourType,
                        deviceimei: this.ruleForm.deviceIMEI,//搜名称
                        deptid:deptid,
                    }
                    if(this.imeiCompare != -1 && this.ruleForm.deviceIMEI == this.imeiCompare){ //编辑
                       if(this.$route.query.IStrue == 'edit'){
                            this.editMonitoringAjax()
                        }
                        sessionStorage.setItem('complete',true) //左侧导航判断内容是否填写完整
                    }else{
                        ajaxFuncJson('/monitoring/checkDeviceList',parms).then(res=>{
                            if(res.data.status == 200){
                                let searchArray = res.data.data
                                           let searchVal = res.data.data
                                            this.ruleForm.type = searchVal[0].type; //检测点类型
                                            this.ruleForm.deviceId = searchVal[0].id;  //设备id
                                 if(searchArray.length == 0){
                                    this.ruleForm.deviceIMEI = '';
                                    this.tips = "当前设备不存在，请重新输入！";
                                    this.ruleForm.type = '';
                                    this.dialogTipsVisible = true;
                                    let that = this;
                                    let test1 = setTimeout(function(){ //提示框
                                        that.dialogTipsVisible = false;
                                        clearTimeout(test1);
                                    },5000)
                                    //  this.handleSelect(this.ruleForm.deviceIMEI)
                                 }else{
                                    if(this.$route.query.IStrue == 'false'){
                                        this.addMonitoringAjax();
                                    }else if(this.$route.query.IStrue == 'edit'){
                                        this.editMonitoringAjax()
                                    }
                                    sessionStorage.setItem('complete',true) //左侧导航判断内容是否填写完整
                                 }
                            }
                        });
                    }
                } else {
                    this.dialogTipsVisible = true;
                    let that = this;
                    let test1 = setTimeout(function(){ //提示框
                        that.dialogTipsVisible = false;
                        clearTimeout(test1);
                    },5000)
                    return false;
                }
                });
            },
            obtainAddressAjax(){ //获取安装地址(查看建筑详情)
            this.ruleForm.customerId = sessionStorage.getItem("customerId"); //赋值客户id
            this.ruleForm.buildingId = sessionStorage.getItem("buildingId");; //赋值建筑id
            let parms = {
                    buildingId: this.ruleForm.buildingId 
                 }
                ajaxFuncJson('/basicData/selectByPrimaryKey',parms).then(res=>{
                    if(res.data.status == 200){
                        this.ruleForm.installAddress = res.data.data.address;
                    }
                })
            },
            addMonitoringAjax(){ //新建监测点
                ajaxFuncJson('/basicData/insertMonitorInfo',this.ruleForm).then(res=>{
                    if(res.data.status == 200){
                      sessionStorage.setItem('saveId',res.data.data); //保存监测点id
                      this.$router.push({path:'/content/saveSuccessfully'}); //跳转保存成功
                    }else if(res.data.status == 305){//设备名已经存在
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 306){//设备编码已经存在
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 307){//当前设备已绑定
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 308){//当前设备已绑定
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }
                })
            },
            getDetails(saveId){ //获取监测点详情
                let parms = {
                        id:saveId
                    }
                    ajaxFuncJson('/basicData/getMonitorInfoById',parms).then(res=>{
                        if(res.data.status == 200){
                            this.ruleForm = res.data.data; //赋值监测点详情
                            this.ruleForm.installAddress = res.data.data.installAddress;
                            sessionStorage.setItem('changeVal',JSON.stringify(this.ruleForm)) // 离开时判断有没有修改过
                            this.imeiCompare = this.ruleForm.deviceIMEI; //比较imei
                            this.FourType = this.ruleForm.type;
                            if(this.FourType == 1){
                                this.devicetypeid = '25e6d6b9948a49f8b1f3f2ebaf7dbaca';
                                this.options = [{
                                    type: '25e6d6b9948a49f8b1f3f2ebaf7dbaca',
                                    label: '电气'
                                }]
                            }else if(this.FourType == 2){
                                this.devicetypeid = '3177e2a539a24a8da5900b5e0fbd0fgg';
                                this.options = [{
                                    type: '3177e2a539a24a8da5900b5e0fbd0fgg',
                                    label: '水压'
                                }]
                            }else if(this.FourType == 3){
                                this.devicetypeid = 'add413d5-3417-4fe7-87f7-6b0917e7a88b';
                                this.options = [{
                                    type: 'add413d5-3417-4fe7-87f7-6b0917e7a88b',
                                    label: '液位'
                                }]
                            }else if(this.FourType == 4){
                                this.devicetypeid = '847ccc1042a54e1aa5aa5eba24554dbb';
                                this.options = [{
                                    type: '847ccc1042a54e1aa5aa5eba24554dbb',
                                    label: '可燃气'
                                }]
                            }else if(this.FourType == 5){
                                this.devicetypeid = '1751add6-a9d9-4fd5-b565-4f24bf5bb65a';
                                this.options = [{
                                    type: '1751add6-a9d9-4fd5-b565-4f24bf5bb65a',
                                    label: '烟感'
                                }]
                            }else if(this.FourType == 6){
                                this.devicetypeid = '337e9236-67c2-4114-8390-f0d0260d7e9b';
                                this.options = [{
                                    type: '337e9236-67c2-4114-8390-f0d0260d7e9b',
                                    label: '灭火器'
                                }]
                            }else if(this.FourType == 7){
                                this.devicetypeid = 'add413d5-3417-4fe7-87f7-6b0917edh3b';
                                this.options = [{
                                    type: 'add413d5-3417-4fe7-87f7-6b0917edh3b',
                                    label: '水浸'
                                }]
                            }else if(this.FourType == 8){
                                this.devicetypeid = 'add413d5-3417-4fe7-87f7-6b0917edjkl';
                                this.options = [{
                                    type: 'add413d5-3417-4fe7-87f7-6b0917edjkl',
                                    label: '用传'
                                }]
                            };
                            //  let deptid;
                            //   if(sessionStorage.getItem("userType")==1){
                            //     deptid = ''
                            //   }else{
                            //     deptid = sessionStorage.getItem("customerId");
                            //   }
                            //   let param123456 = {
                            //     type:this.FourType,
                            //     deptid:deptid,
                            //   }


                            // ajaxFuncJson('/monitoring/checkDeviceList',param123456).then(res=>{
                            //     if(res.data.status == 200){
                            //         this.restaurants = res.data.data; //赋值搜索值
                            //     }
                            // })
                        }
                    })
            },
            editMonitoringAjax(){ //编辑监测点
                ajaxFuncJson('/basicData/updateMonitorInfo',this.ruleForm).then(res=>{
                    if(res.data.status == 200){
                      this.$router.push({path:'/content/saveSuccessfully'}); //跳转保存成功
                    }else if(res.data.status == 305){//设备名已经存在
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 306){//设备编码已经存在
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 307){//当前设备已绑定
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }else if(res.data.status == 308){//当前设备已绑定
                        this.tips = res.data.msg;
                        this.dialogTipsVisible = true;
                        let that = this;
                        let test1 = setTimeout(function(){ //提示框
                            that.dialogTipsVisible = false;
                            clearTimeout(test1);
                        },5000)
                    }
                })
            },
            deleteMonitoringAjax(saveId){ //删除的监测点
                let parms = {
                        id:saveId
                    }
                    ajaxFuncJson('/basicData/checkDelete',parms).then(res=>{
                        if(res.data.status == 200){
                           this.tipsTwo = '确定删除当前监测点？';
                           this.dialogTipsSureVisible = true;
                           this.sureType = 'delete'
                        }else if(res.data.status == 305){//有数据
                            this.tips = res.data.msg;
                            this.dialogTipsVisible = true;
                            let that = this;
                            let test1 = setTimeout(function(){ //提示框
                                that.dialogTipsVisible = false;
                                clearTimeout(test1);
                            },5000)
                        }else if(res.data.status == 306){ //未禁用
                            this.tips = res.data.msg;
                            this.dialogTipsVisible = true;
                            let that = this;
                            let test1 = setTimeout(function(){ //提示框
                                that.dialogTipsVisible = false;
                                clearTimeout(test1);
                            },5000)
                        }
                    })
            },
            searchSeniorAjax(parms){ //高级搜索弹层接口
                ajaxFuncJson('/monitoring/checkDeviceList',parms).then(res=>{
                    if(res.data.status == 200){
                        this.gridData = res.data.data; //赋值搜索值
                    }
                })
            }
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard;
                that.isScroll();
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
  width: 78.1%;
  margin:10px 0 7px 1.05%;
  padding: 0;
  .maindetails{
      min-height: 800px;
      padding: 20px 0;
      padding-left: 70px;
      margin-right: 1.05%;
      background-color:#fff;
  }
}
.inlieInput{
    width:410px;
    @include flexible;
    @include alignItems(center);
    @include justify(space-between);
}
.searchBtn {
    position: relative;
    margin-left: 10px;
    i {
        position: absolute;
        top: 7px;
        left: 10px;
        @include wh(16px,16px);
        @include bgImg('../../assets/img/search2.png');
        z-index: 1;
    }
}
.deviceBinding{
    margin-bottom: 10px;
    @include flexible;
    @include alignItems(center);
}
.txtcolor span{
    color: #282828;
}
#bodyMain{
    .v-modal {
        opacity: .3!important;
        z-index: 0!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/BasicData/addMonitor.vue